
import { JavaCourse } from './types';
import { ENHANCED_JAVA_BASIC_MODULES } from './enhanced-basic-modules';

export const JAVA_BASIC_COURSE: JavaCourse = {
  id: 'java-fundamentals',
  title: 'Java Programming Fundamentals',
  description: 'Learn Java programming from the ground up. Master object-oriented programming concepts, syntax, and core Java features.',
  level: 'beginner',
  totalDuration: '6 hours',
  image: '/api/placeholder/400/300',
  prerequisites: [
    'Basic understanding of computer operations',
    'Familiarity with any programming language (helpful but not required)',
    'Problem-solving mindset'
  ],
  learningOutcomes: [
    'Write well-structured Java programs using OOP principles',
    'Master Java syntax, variables, and control structures',
    'Understand Java compilation and execution process',
    'Handle errors and exceptions effectively',
    'Build interactive console applications'
  ],
  modules: ENHANCED_JAVA_BASIC_MODULES,
  type: 'java'
};
